import { ensureArray } from '../index.js';
import { Observable } from './observable.js';

/**
 * Creates an Observable from an IntersectionObserver.
 *
 * @param target The Element or a list of Elements to observe.
 * @param options Optional IntersectionObserverInit object providing options to customize the observer.
 * @returns An Observable that emits IntersectionObserverEntry objects.
 */
export const createIntersectionObservable = (target: Element | Element[], options?: IntersectionObserverInit) => new Observable<IntersectionObserverEntry>(subscriber => {
    // create IntersectionObserver and emit the entries to the observable whenever the intersection changes
    const observer = new IntersectionObserver(entries => entries.forEach(entry => subscriber.next(entry)), options);
    // register elements to observe
    ensureArray(target).forEach(element => observer.observe(element));
    // add teardown logic to disconnect the observer when the subscription is disposed
    subscriber.addTeardown(() => observer.disconnect());
});
